
export default {
  name: "TitleText",
  props: {
    content: Object,
  },
  computed: {
    wordGroups() {
      if (!this.content || !this.content.title) {
        return [];
      }

      const words = this.content.title.split(' ');
      const groups = [];
      for (let i = 0; i < words.length; i += 2) {
        groups.push(words.slice(i, i + 2));
      }
      return groups;
    }
  },
}
